import qs from 'qs'
import { getParamsConfig, getQuestTokenCode, getRequestConfig, loginFailure } from './request.util'
import { UtilShowToast } from '@/utils/uniVab'
import { hideLoading, showLoading } from '@/utils/loading'

const http = async (options): Promise<IHttpResult<any>> => {
  const method = options.method.toUpperCase()
  const { VITE_BASE_URL } = import.meta.env

  let data: any = {}
  if (method in { GET: true, DELETE: true }) {
    data = options.params
  } else if (method in { POST: true, PUT: true }) {
    data = options.data
  }
  const shouldShowLoading = !data?.hideLoading
  if (shouldShowLoading) {
    showLoading('加载中', true)
  }

  // 获取请求头信息
  const config = await getRequestConfig(options)
  return new Promise((resolve, reject) => {
    uni.request({
      url: VITE_BASE_URL + options.url,
      method: method || 'GET',
      data: data || {},
      header: config.headers,
      success: function (response) {
        setTimeout(() => {
          const resData: any = response.data || response
          if (resData && !resData.success) {
            if (getQuestTokenCode().includes(resData.code)) {
              loginFailure()
            } else {
              UtilShowToast({
                title: resData.message || resData.errMsg || '系统开小差了，请稍后再试',
              })
            }

            console.error('🚀 ~ 接口报错地址:', options.url)
            return reject(resData)
          }
          return resolve(resData)
        }, 0)
      },
      fail: function (error: any) {
        setTimeout(() => {
          UtilShowToast({ title: error.message || error.errMsg })
        }, 0)
      },
      complete: function () {
        if (shouldShowLoading) {
          hideLoading()
        }
      },
    })
  })
}

// 泛型T: 返回接口字段类型 泛型U: 是参数的数据类型
const httpServer = {
  get<T, U = any>(url: string, params: U, headers?: TCustomHeaders): Promise<IHttpResult<T>> {
    return http(getParamsConfig(url, 'get', params, headers))
  },
  post<T, U = any>(url: string, params: U, headers?: TCustomHeaders): Promise<IHttpResult<T>> {
    return http(getParamsConfig(url, 'post', params, headers))
  },
  put<T, U = any>(url: string, params: U, headers?: TCustomHeaders): Promise<IHttpResult<T>> {
    return http(getParamsConfig(url, 'put', params, headers))
  },
  delete<T, U = any>(url: string, params: U, headers?: TCustomHeaders): Promise<IHttpResult<T>> {
    return http(getParamsConfig(url, 'delete', params, headers))
  },
  postForQuery<T, U = any>(url: string, params: U, headers?: any): Promise<IHttpResult<T>> {
    return http(
      getParamsConfig(
        url,
        'post',
        qs.stringify(params, {
          arrayFormat: 'repeat',
        }),
        headers,
      ),
    )
  },
}

export { httpServer }
